import { OrderStopTypeMap } from "@/constants/order";
import type { RouteStopDto } from "@/api/trips/dto/trip.dto";
import type { TripRouteStop } from "@/types/trip";

function withStopAddress(stop: TripRouteStop | RouteStopDto, title: string): string {
  const address = stop.facility?.address;

  return address ? `${title}, ${address}` : title;
}

export function getStopInfoTitle(stop: TripRouteStop | RouteStopDto): string {
  return withStopAddress(stop, `${OrderStopTypeMap[stop.type]} #${stop.number} details`);
}

export function getStopVerifyTitle(stop: TripRouteStop | RouteStopDto): string {
  return withStopAddress(stop, `Verify information · ${OrderStopTypeMap[stop.type]} #${stop.number}`);
}
